import React from "react";
import {Copyright, InfoOutlined} from "@mui/icons-material";

const USE_COPYRIGHT_ICON = false;

/**
 * Extracting icon for overlays to adjust it easily for different branches/modules
 */
export const OverlayIcon = (props) => {
    return USE_COPYRIGHT_ICON ? <Copyright {...props} /> : <InfoOutlined {...props} />;
}
